import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    ADD_EXTRA,
    ADD_EXTRA_SUCCESS,
    ADD_EXTRA_ERROR
}
    from "../../../actions/menu/extras";

function* addExtraSaga(action) {
    try {
        const data =  yield call(extraService.AddExtra, action.payload)
        yield put({
            type: ADD_EXTRA_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_EXTRA_ERROR,error: error.data
        });
    }
}


export function* addExtraSagaWatcher() {
    yield takeLatest(ADD_EXTRA, addExtraSaga);
}